'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _ErrorMessage = require('../Common/ErrorMessage');

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextArea = function (_React$Component) {
    (0, _inherits3.default)(TextArea, _React$Component);

    function TextArea(props) {
        (0, _classCallCheck3.default)(this, TextArea);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TextArea.__proto__ || (0, _getPrototypeOf2.default)(TextArea)).call(this, props));

        _this.onBlur = function (e) {
            if (_this.props.onBlur) {
                _this.props.onBlur(e);
            }
        };

        _this.onChange = function (e) {
            _this.setState({ value: e.currentTarget.value });

            if (_this.props.onChange) {
                _this.props.onChange(e);
            }
        };

        _this.state = {
            value: props.value || ''
        };
        return _this;
    }

    (0, _createClass3.default)(TextArea, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            /* istanbul ignore else */
            if (!(this.state.value === this.props.value === nextProps.value)) {
                this.setState({ value: nextProps.value });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                autoFocus = _props.autoFocus,
                className = _props.className,
                dataTn = _props.dataTn,
                errorMessageAlignment = _props.errorMessageAlignment,
                label = _props.label,
                name = _props.name,
                maxLength = _props.maxLength,
                placeholder = _props.placeholder,
                _props$disabled = _props.disabled,
                disabled = _props$disabled === undefined ? false : _props$disabled,
                errorMessage = _props.errorMessage,
                errorDataTn = _props.errorDataTn,
                rows = _props.rows,
                theme = _props.theme;


            var errorDataTnString = errorDataTn ? errorDataTn : dataTn + '-error';

            if (theme) {
                var textareaClasses = (0, _classnames4.default)((0, _defineProperty3.default)({}, theme.error, !!errorMessage), theme.message, className);
                return _react2.default.createElement(
                    'div',
                    { className: theme.textAreaContainer },
                    label && _react2.default.createElement(
                        'div',
                        { className: theme.label },
                        label
                    ),
                    _react2.default.createElement('textarea', {
                        autoFocus: autoFocus,
                        className: textareaClasses,
                        'data-tn': dataTn,
                        maxLength: maxLength || null,
                        onBlur: this.onBlur,
                        onChange: this.onChange,
                        placeholder: placeholder,
                        rows: rows || 6,
                        name: name,
                        value: this.state.value || '',
                        disabled: disabled
                    }),
                    _react2.default.createElement(_ErrorMessage2.default, {
                        message: errorMessage,
                        dataTn: errorDataTnString,
                        className: (0, _classnames4.default)(theme.errorMessage, (0, _defineProperty3.default)({}, theme.errorMessageRight, errorMessageAlignment === 'right'))
                    })
                );
            }
            return null;
        }
    }]);
    return TextArea;
}(_react2.default.Component);

TextArea.defaultProps = {
    autoFocus: false,
    errorMessageAlignment: 'right',
    value: ''
};


TextArea.displayName = 'TextArea';

exports.default = TextArea;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/lib/TextArea/index.js
// module id = ./node_modules/dibs-elements/lib/TextArea/index.js
// module chunks = 4